import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TABS } from '../../config/employeeDetailSections';
import { NAV_TABS } from '../../config/employeeDetailTokens';
import { SubNavBar } from '../../../../components/ui/subNavBar/SubNavBar';

interface NavTabsProps {
  tab: number;
  onChange: (v: number) => void;
  /**
   * TABS indexes the connected profile may display (HOMCO-640). Only these tabs
   * are rendered; each keeps its ORIGINAL TABS index as value so the page can go
   * on rendering content by numeric index.
   */
  visibleIndexes: number[];
}

export function NavTabs({ tab, onChange, visibleIndexes }: NavTabsProps) {
  const { t } = useTranslation('common');

  const items = visibleIndexes.map(i => ({ value: i, label: t(`employeeDetail.tabs.${TABS[i]}`) }));

  return (
    <Box
      sx={{
        bgcolor: NAV_TABS.bg,
        borderBottom: NAV_TABS.border,
        boxShadow: NAV_TABS.shadow,
        // Stickiness is owned by the SubHeader+NavTabs wrapper in EmployeeDetailPage
        // (pinned below the fixed navbar); this bar only carries its own styling.
        px: 3,
        overflowX: 'auto',
      }}
    >
      <SubNavBar<number> items={items} value={tab} onChange={onChange} />
    </Box>
  );
}
